import React from "react";
import QuoteForm from "@/components/QuoteForm";
import Seo from "@/components/Seo";
import { BRAND, CLIENT_TYPES } from "@/site.config";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <main data-testid="contact-page" className="pt-32">
      <Seo
        title="Contact & devis gratuit — SIGNA CLEAN Martinique (Fort-de-France)"
        description="Demandez votre devis gratuit. SIGNA CLEAN — Immeuble EQUINOXES, 12 rue des Arts et Métiers, Lotissement Dillon Stade, 97200 Fort-de-France. Téléphone : 0696 68 77 66. Lun-Ven 8h-16h. Intervention sur toute la Martinique."
        keywords="contact SIGNA CLEAN, devis gratuit nettoyage Martinique, entreprise nettoyage Fort-de-France, plots solaires devis Martinique, lessivage devis Martinique"
        canonical="https://signaclean.fr/contact"
      />
      <section className="px-5 sm:px-8 pb-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#9DEB30] mb-3">
            · Nous contacter
          </div>
          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight max-w-4xl">
            Parlons de votre <span className="text-[#9DEB30] neon-text">projet.</span>
          </h1>
          <p className="mt-6 text-zinc-400 max-w-2xl">
            Devis gratuit sous 24-48 h. Particuliers, entreprises, collectivités, bailleurs sociaux —
            nous étudions chaque demande avec attention.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: Phone, k: "Téléphone", v: BRAND.phone, href: BRAND.phoneHref },
              { icon: Mail, k: "Email", v: BRAND.email, href: BRAND.emailHref },
              { icon: MapPin, k: "Adresse", v: BRAND.address.full },
              { icon: Clock, k: "Horaires", v: BRAND.hours },
            ].map((c, i) => {
              const Icon = c.icon;
              const inner = (
                <>
                  <div className="h-11 w-11 rounded-xl flex items-center justify-center bg-[#9DEB30]/10 border border-[#9DEB30]/30 text-[#9DEB30] mb-4">
                    <Icon size={18} />
                  </div>
                  <div className="text-xs font-mono uppercase tracking-wider text-zinc-500">{c.k}</div>
                  <div className="font-display text-lg font-bold mt-1">{c.v}</div>
                </>
              );
              return c.href ? (
                <a
                  key={i}
                  href={c.href}
                  data-testid={`contact-info-${i}`}
                  className="block p-6 rounded-2xl border border-white/10 hover:border-[#9DEB30]/40 transition"
                >
                  {inner}
                </a>
              ) : (
                <div
                  key={i}
                  data-testid={`contact-info-${i}`}
                  className="p-6 rounded-2xl border border-white/10"
                >
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <QuoteForm id="formulaire" />

      <section className="px-5 sm:px-8 pb-24">
        <div className="max-w-7xl mx-auto p-8 rounded-2xl border border-white/10 bg-[#0d0d0d]">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">
            · Pour qui ?
          </div>
          <div className="flex flex-wrap gap-3">
            {CLIENT_TYPES.map((c, i) => (
              <span
                key={i}
                className="px-4 py-2 rounded-full border border-[#9DEB30]/30 bg-[#9DEB30]/[0.04] text-sm text-zinc-200"
              >
                {c}
              </span>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
